import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  AppTokenService,
  AuthAccessTokenDetails,
  handleError,
  HttpHeadersPayload,
  HttpRequestMethods,
  LoginRememberMeUtilsService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';

import { Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { DEFAULT_TIMEOUT } from '../constants/my-trip-constants';
import {
  BEARER,
  HEADER,
  HTTP_HEADERS,
  MOST_UPCOMING_TRIP,
  MyTripEndpointKeys
} from '../models/enums/my-trip.enums';
import {
  MostUpcomingTrip,
  MostUpcomingTripParams
} from '../models/interface/upcoming-trip.interface';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  accessToken = '';
  errorHandler = handleError.bind(this);

  constructor(
    private readonly http: HttpClient,
    private readonly appConfig: AppConfigService,
    private readonly utils: LoginRememberMeUtilsService,
    private readonly appToken: AppTokenService
  ) {}

  handleError(httpErrorResponse: HttpErrorResponse): Observable<never> {
    return throwError(httpErrorResponse);
  }

  getHeaders = (): HttpHeadersPayload => {
    return {
      Authorization: BEARER + ' ' + this.accessToken
    };
  };

  getToken(): Observable<AuthAccessTokenDetails> {
    return this.appToken.getAppTokenWithParams('', '', true);
  }

  callMostUpcomingTrips = (
    tripDetails: MostUpcomingTripParams
  ): Observable<MostUpcomingTrip> => {
    return this.getToken().pipe(
      switchMap((tokenDetails: AuthAccessTokenDetails) => {
        if (tokenDetails.access_token) {
          this.accessToken = tokenDetails.access_token;
          return this.getMostUpcomingTripsDetails(tripDetails);
        }
        return of({} as MostUpcomingTrip);
      })
    );
  };

  getMostUpcomingTripsDetails = (
    tripDetails: MostUpcomingTripParams
  ): Observable<MostUpcomingTrip> => {
    const transactionId = `${
      HTTP_HEADERS.MY_TRIP
    }_${this.utils.generateUniqueIdentifier()}`;
    return new ApiBuilder<unknown, MostUpcomingTrip>(this.http, this.appConfig)
      .overrideEndpoint([
        {
          src: MOST_UPCOMING_TRIP.SKY_MILE_NUMBER,
          target: tripDetails.skyMileNumber
        },
        {
          src: MOST_UPCOMING_TRIP.NO_OF_TRIPS,
          target: tripDetails.numberOfTrips
        },
        {
          src: MOST_UPCOMING_TRIP.TRANSACTION_ID,
          target: transactionId
        }
      ])
      .app(HEADER)
      .endpointKey(MyTripEndpointKeys.APP_TRIPS_UPCOMING_TRIP_URL)
      .method(HttpRequestMethods.POST)
      .httpHeaders(this.getHeaders())
      .errorHandler(this.errorHandler)
      .timeOut(DEFAULT_TIMEOUT)
      .create()
      .pipe(
        map((response: MostUpcomingTrip) => response),
        catchError((err) => this.handleError(err))
      );
  };
}
